import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
export const LoadingState = ({ title }) => (<Card>
        <CardHeader>
            <CardTitle className="text-base">{title}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2">
            <Skeleton className="h-4 w-1/3"/>
            <Skeleton className="h-8 w-full"/>
            <Skeleton className="h-8 w-full"/>
        </CardContent>
    </Card>);
LoadingState.displayName = 'LoadingState';
